import { AiOutlineCamera, AiOutlinePlus } from "react-icons/ai";
import { IoMdRefresh } from "react-icons/io";
import { RiDeleteBinLine } from "react-icons/ri";

const AddPhoto = () => {
  return (
    <div>
      <h5 className="mt-8 mb-4 font-pop text-xl font-medium text-secondary">
        Add Photos
      </h5>
      <div className="w-full border border-solid border-inputBorder px-16 py-6">
        <h5 className="mb-4 font-pop text-xl font-medium text-black text-opacity-50">
          Main Photo
        </h5>
        <div className=" flex flex-wrap items-center gap-y-8 gap-x-8">
          <div className=" h-[178px] w-[150px]">
            <img src="assets/images/auction_listing/carimg.png" alt="carimg" />
            <div className="mt-2 flex items-center justify-center gap-x-6">
              <RiDeleteBinLine className="h-5 w-5 cursor-pointer" />
              <IoMdRefresh className="h-5 w-5 cursor-pointer" />
            </div>
          </div>
          <div className=" h-[178px] w-[150px]">
            <div className="relative flex h-[150px] w-[150px] items-center justify-center bg-[#F3F3F3]">
              <AiOutlineCamera className="h-[48px] w-[48px] text-secondary" />
              <AiOutlinePlus className="absolute top-[77px] right-[56px] rounded-full bg-secondary text-white" />
            </div>
            <div className="mt-2 flex items-center justify-center gap-x-6">
              <RiDeleteBinLine className="h-5 w-5 cursor-pointer" />
              <IoMdRefresh className="h-5 w-5 cursor-pointer" />
            </div>
          </div>
          <div className=" h-[178px] w-[150px]">
            <div className="relative flex h-[150px] w-[150px] items-center justify-center bg-[#F3F3F3]">
              <AiOutlineCamera className="h-[48px] w-[48px] text-secondary" />
              <AiOutlinePlus className="absolute top-[77px] right-[56px] rounded-full bg-secondary text-white" />
            </div>
            <div className="mt-2 flex items-center justify-center gap-x-6">
              <RiDeleteBinLine className="h-5 w-5 cursor-pointer" />
              <IoMdRefresh className="h-5 w-5 cursor-pointer" />
            </div>
          </div>
          <div className=" h-[178px] w-[150px]">
            <div className="relative flex h-[150px] w-[150px] items-center justify-center bg-[#F3F3F3]">
              <AiOutlineCamera className="h-[48px] w-[48px] text-secondary" />
              <AiOutlinePlus className="absolute top-[77px] right-[56px] rounded-full bg-secondary text-white" />
            </div>
            <div className="mt-2 flex items-center justify-center gap-x-6">
              <RiDeleteBinLine className="h-5 w-5 cursor-pointer" />
              <IoMdRefresh className="h-5 w-5 cursor-pointer" />
            </div>
          </div>
          <div className=" h-[178px] w-[150px]">
            <div className="relative flex h-[150px] w-[150px] items-center justify-center bg-[#F3F3F3]">
              <AiOutlineCamera className="h-[48px] w-[48px] text-secondary" />
              <AiOutlinePlus className="absolute top-[77px] right-[56px] rounded-full bg-secondary text-white" />
            </div>
            <div className="mt-2 flex items-center justify-center gap-x-6">
              <RiDeleteBinLine className="h-5 w-5 cursor-pointer" />
              <IoMdRefresh className="h-5 w-5 cursor-pointer" />
            </div>
          </div>
          <div className=" h-[178px] w-[150px]">
            <div className="relative flex h-[150px] w-[150px] items-center justify-center bg-[#F3F3F3]">
              <AiOutlineCamera className="h-[48px] w-[48px] text-secondary" />
              <AiOutlinePlus className="absolute top-[77px] right-[56px] rounded-full bg-secondary text-white" />
            </div>
            <div className="mt-2 flex items-center justify-center gap-x-6">
              <RiDeleteBinLine className="h-5 w-5 cursor-pointer" />
              <IoMdRefresh className="h-5 w-5 cursor-pointer" />
            </div>
          </div>
          <div className=" h-[178px] w-[150px]">
            <div className="relative flex h-[150px] w-[150px] items-center justify-center bg-[#F3F3F3]">
              <AiOutlineCamera className="h-[48px] w-[48px] text-secondary" />
              <AiOutlinePlus className="absolute top-[77px] right-[56px] rounded-full bg-secondary text-white" />
            </div>
            <div className="mt-2 flex items-center justify-center gap-x-6">
              <RiDeleteBinLine className="h-5 w-5 cursor-pointer" />
              <IoMdRefresh className="h-5 w-5 cursor-pointer" />
            </div>
          </div>
          <div className=" h-[178px] w-[150px]">
            <div className="relative flex h-[150px] w-[150px] items-center justify-center bg-[#F3F3F3]">
              <AiOutlineCamera className="h-[48px] w-[48px] text-secondary" />
              <AiOutlinePlus className="absolute top-[77px] right-[56px] rounded-full bg-secondary text-white" />
            </div>
            <div className="mt-2 flex items-center justify-center gap-x-6">
              <RiDeleteBinLine className="h-5 w-5 cursor-pointer" />
              <IoMdRefresh className="h-5 w-5 cursor-pointer" />
            </div>
          </div>
          <div className=" h-[178px] w-[150px]">
            <div className="relative flex h-[150px] w-[150px] items-center justify-center bg-[#F3F3F3]">
              <AiOutlineCamera className="h-[48px] w-[48px] text-secondary" />
              <AiOutlinePlus className="absolute top-[77px] right-[56px] rounded-full bg-secondary text-white" />
            </div>
            <div className="mt-2 flex items-center justify-center gap-x-6">
              <RiDeleteBinLine className="h-5 w-5 cursor-pointer" />
              <IoMdRefresh className="h-5 w-5 cursor-pointer" />
            </div>
          </div>
          <div className=" h-[178px] w-[150px]">
            <div className="relative flex h-[150px] w-[150px] items-center justify-center bg-[#F3F3F3]">
              <AiOutlineCamera className="h-[48px] w-[48px] text-secondary" />
              <AiOutlinePlus className="absolute top-[77px] right-[56px] rounded-full bg-secondary text-white" />
            </div>
            <div className="mt-2 flex items-center justify-center gap-x-6">
              <RiDeleteBinLine className="h-5 w-5 cursor-pointer" />
              <IoMdRefresh className="h-5 w-5 cursor-pointer" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPhoto;
